import axios from "axios";

/**
 * Function to create a new antagonism test
 * @param {Object} context - Vuex context.
 * @param {Object} payload - Antagonism info.
 */
export async function getBioativeBankList({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/getBioativeBankList",
      payload
    );
    // Fetch antagonism list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

/**
 * Function to create a new antagonism test
 * @param {Object} context - Vuex context.
 * @param {Object} payload - Antagonism info.
 */
export async function getPreservedsList({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/getPreservedsList", payload);
    // Fetch antagonism list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

/**
 * Function to search identifications by name
 * @param {function} { commit } - vuex function
 * @param {Object} { rootState } - vuex store object
 * @param {String} payload - string to search within identifications
 * @returns {data} -  Returns array of identifications
 */
export async function searchBioactives({ commit, rootState }, payload) {
  try {
    const { data } = await axios.get("/bioactive/search", {
      params: payload,
      cancelToken: rootState.cancelToken && rootState.cancelToken.token,
    });

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function searchIdentification({ commit, rootState }, payload) {
  try {
    const { data } = await axios.get("/bioactive/search-identification", {
      params: payload,
      cancelToken: rootState.cancelToken && rootState.cancelToken.token,
    });

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function addStrainRequest({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/addStrainRequest", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function addPreserved({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/addPreserved", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function reactivePreserved({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/reactivePreserved", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function getMorphology({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/getMorphology", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function updateReactivation({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/updateReactivation", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function deliveryReactivation({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/deliveryReactivation",
      payload
    );

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function revertDelivery({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/revert-delivery", payload);

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function searchReactivation({ commit, rootState }, payload) {
  try {
    const { data } = await axios.get("/bioactive/searchReactivation", {
      params: payload,
      cancelToken: rootState.cancelToken && rootState.cancelToken.token,
    });
    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function makeContaminated({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/makeContaminated", payload);
    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function preservedContaminated({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/preservedContaminated", payload);
    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function preservedsContaminated({ commit }, payload) {
  try {
    const { data } = await axios.post("/lotes/preserveds-contaminated", payload);
    if (data.error) throw data;

    return data;
  } catch (e) {
    throw Error(e.message)
  }
}

/**
 * Function to upload isolate photo to aws s3
 * @param {Object} { state, dispatch } - vuex functions
 * @param {Image} image - isolate image
 */
export async function uploadStrainPhoto({ state }, image) {
  try {
    const { data } = await axios.post("/bioactive/uploadImageStrain", image);
    if (data.error) throw data;
    return data;
  } catch (error) {
    return error;
  }
}

/**
 * Function to upload isolate photo to aws s3
 * @param {Object} { state, dispatch } - vuex functions
 * @param {Image} image - isolate image
 */
export async function updateEvidenceReactivation({ state }, image) {
  try {
    const { data } = await axios.post(
      "/bioactive/updateEvidenceReactivation",
      image
    );
    if (data.error) throw data;
    return data;
  } catch (error) {
    return error;
  }
}

/**
 * Function to create a new nematode identification
 * @param {Object} { commit } - Vuex function
 * @param {Object} identif - Identification info
 */
export async function addIdentification({ commit }, identif) {
  try {
    const { data } = await axios.post("/bioactive/addIdentification", identif);
    if (data.error) throw data;
    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function addBioactiveStrain({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/addBioactiveStrain", payload);
    if (data.error) throw data;
    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function updateBioactiveStrain({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/update-bioactive-strain",
      payload
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function deliveryAllPreserveds({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/delivery-all-preserveds",
      payload
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw e;
  }
}

export async function addNewIdentification({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioactive/add-identification", payload);
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw e;
  }
}

export async function getStrainRequestHistory({ commit, rootState }, payload) {
  try {
    const { data } = await axios.get("/bioactive/history", {
      params: payload,
    });

    if (data.error) throw data;

    return data;
  } catch (e) {
    return e.response.data;
  }
}

export async function cancelStrainRequest({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/cancel-strain-request",
      payload
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw e;
  }
}

export async function confirmStrainRequest({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/confirm-strain-request",
      payload
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw e;
  }
}

export async function updateStrainRequest({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/bioactive/update-strain-request",
      payload
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw e;
  }
}
